<div *ngIf="reportType == ApplicantPdfReportTypeEnum.DetailPdf && isPdfDownload && isTranslationsLoaded">
    <app-detail-pdf-report 
        [positionTitle]="positionTitle"
        [organizationImageUrl]="organizationImageUrl"
        [applicant]="applicantProfile"
        [organizationName]="organizationName"
        [applicationStepsData]="applicationStepsInfo"
        [answeredQuestionsWithId]="answeredQuestionsWithId"
        [languageAnsweredQuestions]="languageAnsweredQuestions"
        [totalScore]="totalScore"
        [isPdfGeneratedEventUsing]="isPdfGeneratedEventUsing"
        (pdfGeneratedEvent)="onPdfGeneratedEvent($event)"
        ></app-detail-pdf-report>
</div>

<div *ngIf="reportType == ApplicantPdfReportTypeEnum.SummaryPdf && isPdfDownload && isTranslationsLoaded">
    <app-summary-pdf-report
        [positionTitle]="positionTitle"
        [applicant]="applicantProfile"
        [organizationImageUrl]="organizationImageUrl"
        [organizationName]="organizationName"
        [applicationStepsData]="applicationStepsInfo"
        [answeredQuestionsWithId]="answeredQuestionsWithId"
        [languageAnsweredQuestions]="languageAnsweredQuestions"
        [totalScore]="totalScore"
        [isPdfGeneratedEventUsing]="isPdfGeneratedEventUsing"
        (pdfGeneratedEvent)="onPdfGeneratedEvent($event)"
    ></app-summary-pdf-report>
</div>

<div *ngIf="(aiReportData ?? false) && reportType == ApplicantPdfReportTypeEnum.AIPdf && isPdfDownload && isTranslationsLoaded">
    <app-ai-pdf-report
        [positionTitle]="positionTitle"
        [organizationImageUrl]="organizationImageUrl"
        [totalScore]="totalScore"
        [applicant]="applicantProfile"
        [applicationStepsData]="applicationStepsInfo"
        [answeredQuestionsWithId]="answeredQuestionsWithId"
        [languageAnsweredQuestions]="languageAnsweredQuestions"
        [aiReportData]="aiReportData"
        [organizationName]="organizationName"
        [isPdfGeneratedEventUsing]="isPdfGeneratedEventUsing"
        (pdfGeneratedEvent)="onPdfGeneratedEvent($event)"
    ></app-ai-pdf-report>
</div>
